export default {
  statScientistsTitle: "Scienziati e ricercatori",
  statScientistsDescription: "Professionisti dedicati che guidano l'innovazione nella ricerca e sviluppo farmaceutico",
  statScientistsImage: "https://readdy.ai/api/search-image?query=Professionisti%20farmaceutici%20scienziati%20e%20ricercatori%20che%20lavorano%20in%20laboratorio%20moderno&width=400&height=300",
  statProductsTitle: "Prodotti farmaceutici",
  statProductsDescription: "Portafoglio completo di prodotti farmaceutici e API di alta qualità",
  statProductsImage: "https://readdy.ai/api/search-image?query=Portafoglio%20completo%20di%20prodotti%20farmaceutici%20di%20alta%20qualit%C3%A0&width=400&height=300",
  statMarketsTitle: "Mercati globali",
  statMarketsDescription: "Soddisfare le esigenze sanitarie in vari mercati internazionali con eccellenza normativa",
  statMarketsImage: "https://readdy.ai/api/search-image?query=Mercati%20farmaceutici%20globali%20e%20distribuzione%20sanitaria%20internazionale&width=400&height=300",
};

